import { variation } from 'ember-launch-darkly';

import BaseAbility from './base-ability';
import {
  PREFIX_RESOURCE_MANAGER_ORGANIZATIONS,
  ACTION_LIST_ROLES,
} from '../utils/permission-types/index';

export default class extends BaseAbility {
  // This is intentionally ORGANIZATIONS because the list roles page
  // is driven by the resource-manager.organizations.list-roles role.
  prefix = PREFIX_RESOURCE_MANAGER_ORGANIZATIONS;

  /** @return {boolean} */
  get canList() {
    return (
      variation('hcp-ui-view-roles') &&
      this.permissions.scopedPermissions?.organization?.includes(
        this.generate(ACTION_LIST_ROLES),
      )
    );
  }
}
